export const AUDITOR_REVIEW = "AUDITOR_REVIEW" as const;
export const QA_REVIEW = "QA_REVIEW" as const;
export const CODER_REVIEW = "CODER_REVIEW" as const;
export const COMPLETED_CASES = "COMPLETED_CASES" as const;

export const defaultAuditorReviewCaseDataCountList = [
  { label: "Total Cases:", value: 0, key: "TOTAL_CASES", auditCaseIds: "" },
  { label: "New:", value: 0, key: "NEW", auditCaseIds: "" },
  { label: "In Progress:", value: 0, key: "IN_PROGRESS", auditCaseIds: "" },
] as const;

export const defaultQaReviewCaseDataCountList = [
  {
    label: "Total Cases:",
    value: 0,
    key: "TOTAL_CASES",
    auditCaseIds: "",
  },
  {
    label: "QA Review in Progress:",
    value: 0,
    key: "IN_PROGRESS",
    auditCaseIds: "",
  },
  {
    label: "QA Review Complete:",
    value: 0,
    key: "COMPLETE",
    auditCaseIds: "",
  },
] as const;

export const defaultCoderReviewCaseDataCountList = [
  {
    label: "Total Cases:",
    value: 0,
    key: "TOTAL_CASES",
    auditCaseIds: "",
  },
  {
    label: "Coder Review New:",
    value: 0,
    key: "NEW",
    auditCaseIds: "",
  },
  {
    label: "Coder Review In Progress:",
    value: 0,
    key: "IN_PROGRESS",
    auditCaseIds: "",
  },
  {
    label: "Coder Review Rebuttal:",
    value: 0,
    key: "REBUTTAL",
    auditCaseIds: "",
  },
  {
    label: "Coder Review Lapsed:",
    value: 0,
    key: "LAPSED",
    auditCaseIds: "",
  },
  {
    label: "Coder Review Complete:",
    value: 0,
    key: "COMPLETE",
    auditCaseIds: "",
  },
] as const;

export const defaultCompletedCasesDataCountList = [
  { label: "Last 7 days:", value: 0, key: "LAST_ONE_WEEK", auditCaseIds: "" },
  { label: "Last 14 days:", value: 0, key: "LAST_TWO_WEEK", auditCaseIds: "" },
  {
    label: "Last 21 days:",
    value: 0,
    key: "LAST_THREE_WEEK",
    auditCaseIds: "",
  },
  { label: "Last 30 days:", value: 0, key: "LAST_MONTH", auditCaseIds: "" },
] as const;

export const auditorReviewKeysOrder = [
  "TOTAL_CASES",
  "NEW",
  "IN_PROGRESS",
] as const;

export const qaReviewKeysOrder = [
  "TOTAL_CASES",
  "IN_PROGRESS",
  "COMPLETE",
] as const;

export const coderReviewKeysOrder = [
  "TOTAL_CASES",
  "NEW",
  "IN_PROGRESS",
  "REBUTTAL",
  "LAPSED",
  "COMPLETE",
] as const;

export const completedCasesKeysOrder = [
  "LAST_ONE_WEEK",
  "LAST_TWO_WEEK",
  "LAST_THREE_WEEK",
  "LAST_MONTH",
] as const;
